export default __webpack_public_path__ + "static/media/account_blue.16add592.svg";